import React, { useState, useEffect } from 'react';
import Switch from '@mui/material/Switch';
import UiTooltipLabel from './UiTooltipLabel';
import UiFieldWrapper from './UiFieldWrapper';
import UiBaseField from './UiBaseField';
import { InputLabel, FormHelperText, Button } from '@mui/material';
import { getFieldData } from './UiFieldHelpers';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


type IPropsUiSwitchField = UiBaseField & {
    uncheckWarning?: boolean,
    fieldTochange?: string
}

export const UiSwitchField = (props: IPropsUiSwitchField) => {
    const [open, setOpen] = React.useState(false);
    const {error, name, value} = getFieldData(props);
    const label = UiTooltipLabel({ label: props.label, tooltip: props.tooltip })
    const [checked, setChecked] = useState(value ? value : false);
    useEffect(() => setChecked(value ? value : false), [value]);

    const { form, fieldToChange } = props;
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newChecked = event.target.checked;
    
        form?.setFieldValue(name, newChecked);
        setChecked(newChecked);
    
        if (props.onChange) {
            props.onChange(event);
        }
        if (newChecked === false && props.uncheckWarning && fieldToChange) {
            if (form?.getFieldProps(fieldToChange).value) {
                setOpen(true);
            }
        }
    };

    const setField = (fieldname: string) => {
        if(Array.isArray(form?.values[fieldname]))
            form?.setFieldValue(fieldname, []);
        else
            form?.setFieldValue(fieldname, '');
    }

    const handleClose=()=>{
        setOpen(false);
    }

    const handleConfirm=()=>{
        if(fieldToChange) {
            setField(fieldToChange)
        }
        setChecked(false);
        setOpen(false);
        form?.setFieldValue(props.field.name, false);
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure to diselect this
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button name="noBtn" onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button data-yes-button id="yesDialogBtn" onClick={handleConfirm} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <UiFieldWrapper name="ui-switch-field" hideTooltip={true} {...props}>
                <InputLabel error={error.hasError} className="ui-switch-field__label ui-field__label">
                    {label}
                    {error.hasError && <FormHelperText error={error.hasError}>{error.errorMessage}</FormHelperText> }
                </InputLabel>
                <div className="ui-switch-field__field ui-field__field">
                    <Switch
                        id={props.id}
                        checked={checked}
                        disabled={props.disabled}
                        name={name}
                        onChange={handleChange}
                    />
                </div>
            </UiFieldWrapper>
        </React.Fragment>
    )
}
export default UiSwitchField